export const getTranslatedRegion = (region: string) => {
  const regionsTranslations = {
    sicily: ['sicily', 'sicilia', 'sizilien', 'sicile'],
    puglia: ['puglia', 'apulien', 'pouilles'],
  };

  if (regionsTranslations.sicily.includes(region)) {
    return 'sicily';
  }

  return 'puglia';
};
